import React, { Children, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  Select,
  Spin,
  Table,
} from "antd";

import { notificationErroInternal, notificationSucess } from "util/api-utils";
import {
  getCashFlowByFilter,
  getIncome,
  getIncomeV2,
  getStatus,
} from "services/client/client-service";
import {
  ColumnsIncomeStatementCategoryExpend,
  ColumnsIncomeStatementExpend,
  ColumnsIncomeStatementExpendV2,
  getMonthNames,
  replaceMonthV2,
} from "./columns-table";
import dayjs from "dayjs";
import moment from "moment";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { getBanks } from "services/dashboard/dashboard-service";
import {
  ColumnsCategoryData,
  ColumnsCategoryDataCompetence,
  ColumnsCategoryDataDueDateCompetence,
} from "../cash-flow-client/columns-table-moth";
dayjs.extend(customParseFormat);

const dateFormat = "MM/YYYY";
const { info } = Modal;

const IncomeStatementV2 = () => {
  const [loadingData, setLoadingData] = useState(true);
  const [data, setData] = useState({ mapping: [], months: [] });
  const [filterStartDate, setStartDate] = useState(
    moment(moment().year() + "-01").format(dateFormat)
  );
  const [filterEndDate, setEndDate] = useState(
    moment(moment().year() + "-12").format(dateFormat)
  );
  const [filterStartDateValidTable, setFilterStartDateValidTable] = useState(
    moment(moment().year() + "-01").format(dateFormat)
  );
  const [filterEndDateValidTable, setFilterEndDateValidTable] = useState(
    moment(moment().year() + "-12").format(dateFormat)
  );
  const [banks, setBanks] = useState([]);
  const [filterBanks, setFilterBanks] = useState([]);
  const [status, setStatus] = useState([]);
  const [filterStatus, setFilterStatus] = useState([]);
  const formRef = React.useRef(null);
  const [typeDate, setTypeDate] = useState("COMPETENCE");
  const [dataV2, setDataV2] = useState([]);
  const [dataV2Open, setDataV2Open] = useState([]);

  useEffect(() => {
    getStatus()
      .then((res) => {
        let selectStatus = res.map((obj) => ({
          value: obj.name,
          label: obj.name,
        }));

        let resIdStatus = res
          .filter((item) => item.name != "Cancelado")
          .map((item) => item.name);
        setFilterStatus(resIdStatus);
        setStatus(selectStatus);
        getBanks().then((res) => {
          let selectBank = res.map((obj) => ({
            value: obj.codeAccount,
            label: obj.description,
          }));
          selectBank.push({ value: "WITHOUT_BANK", label: "Em Branco" });

          let resIdBank = res.map((item) => item.codeAccount);
          resIdBank.push("WITHOUT_BANK");

          setFilterBanks(resIdBank);
          setBanks(selectBank);
          formRef.current?.setFieldsValue({
            banks: resIdBank,
            status: resIdStatus,
          });

          getMappingDataV2(resIdStatus, resIdBank);
        });
      })

      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }, []);

  function getMappingDataV2(filterStatus, filterBanks) {
    const filter = {
      start: filterStartDate,
      end: filterEndDate,
      status: filterStatus,
      banks: filterBanks,
      type: typeDate,
    };
    setFilterStartDateValidTable(filterStartDate);
    setFilterEndDateValidTable(filterEndDate);
    getIncomeV2(filter)
      .then((res) => {
        setDataV2(res);
        setDataV2Open(
          res
            .filter((item) => item.type_value === "GROUP")
            .map((item) => ({ ...item, showChildren: false }))
        );
        setLoadingData(false);
      })
      .catch((err) => {
        setLoadingData(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const refreshData = () => {
    setLoadingData(true);
    if (!filterStatus.includes("Conciliado")) {
      filterStatus.push("Conciliado");
    }
    if (!filterStatus.includes("Quitado")) {
      filterStatus.push("Quitado");
    }

    getMappingDataV2(filterStatus, filterBanks);
  };

  const setFilterStartDate = (e) => {
    if (e == null) {
      setStartDate(moment().format(dateFormat));
    } else {
      setStartDate(e.format(dateFormat));
    }
  };
  const setFilterEndDate = (e) => {
    if (e == null) {
      setEndDate(moment().format(dateFormat));
    } else {
      setEndDate(e.format(dateFormat));
    }
  };

  const setFilterBank = (e) => {
    if (e.length == 0) {
      let selectBank = banks.map((obj) => obj.value);
      setFilterBanks(selectBank);
    } else {
      setFilterBanks(e);
    }
  };
  const changeFilterStatus = (e) => {
    if (e.length == 0) {
      let statusFilter = status.map((obj) => obj.value);
      setFilterStatus(statusFilter);
    } else {
      setFilterStatus(e);
    }
  };
  function showAllCashFlow(data, category) {
    info({
      title: <div style={{ textAlign: "center" }}>Dados de {category}</div>,
      icon: null,
      content: (
        <div style={{ textAlign: "center" }}>
          <Table
            columns={
              typeDate == "COMPETENCE"
                ? ColumnsCategoryDataCompetence
                : ColumnsCategoryDataDueDateCompetence
            }
            dataSource={data}
            pagination={{ pageSize: 5 }}
            locale={{
              emptyText: "Sem registro",
            }}
          />
        </div>
      ),
      width: "50%",
      centered: true,
      onOk() {},
    });
  }
  const selectPropsBank = {
    mode: "multiple",
    style: {
      width: "100%",
    },
    options: banks,
    onChange: (newValue) => {
      setFilterBank(newValue);
    },
    placeholder: "Selecione o banco",
    maxTagCount: "responsive",
  };

  const selectPropsStatus = {
    mode: "multiple",
    style: {
      width: "100%",
    },
    options: status,
    onChange: (newValue) => {
      changeFilterStatus(newValue);
    },
    placeholder: "Selecione o status",
    maxTagCount: "responsive",
  };

  const showDetails = (key, data, month) => {
    let dataCashFlow = [];
    var monthName = month;

    var filterDateCategoryStart = "01/" + filterStartDate;
    var filterDateCategoryEnd = "01/" + filterEndDate;
    if (data[month] == 0) {
      return;
    }
    if (key != "total") {
      const [monthNameFilter, year] = filterStartDate.split("/").map(Number);
      filterDateCategoryStart = "01/" + key + "/" + year;
      filterDateCategoryEnd = "01/" + key + "/" + year;

      monthName = replaceMonthV2(month);
    }
    setLoadingData(true);

    const filter = {
      start: filterDateCategoryStart,
      end: filterDateCategoryEnd,
      status: filterStatus,
      banks: filterBanks,
      type: typeDate,
      categoryName: data.grupo,
    };
    getCashFlowByFilter(filter)
      .then((res) => {
        showAllCashFlow(res, data.grupo + " - " + monthName);

        setLoadingData(false);
      })
      .catch((err) => {
        setLoadingData(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  };

  let size = 400;
  let sizeDiv = "100%";
  let months = getMonthNames(
    "01/" + filterStartDateValidTable,
    "01/" + filterEndDateValidTable
  );
  switch (months.length) {
    case 1:
      sizeDiv = "50%";
      break;
    case 2:
      size = 800;
      sizeDiv = "80%";
      break;
    case 3:
      size = 800;

      sizeDiv = "100%";
      break;
    case 4:
      size = 1500;

      sizeDiv = "100%";
      break;

    case 5:
      size = 1500;

      sizeDiv = "100%";
    case 6:
      size = 2500;

      sizeDiv = "100%";
      break;
    case 7:
      size = 2500;
      sizeDiv = "100%";

      break;
    case 8:
      size = 2500;
      sizeDiv = "100%";

      break;
    case 9:
      size = 3000;
      sizeDiv = "100%";

      break;
    case 10:
      size = 3000;
      sizeDiv = "100%";

      break;
    case 11:
      size = 3000;
      sizeDiv = "100%";

      break;
    case 12:
      size = 3500;
      sizeDiv = "100%";

      break;
    default:
      break;
  }

  return (
    <div className="container-income">
      <Row gutter={24} style={{ padding: "10px" }}>
        <Col span={24}>
          <Card
            title={"Filtros"}
            bordered={false}
            extra={
              <Button type="primary" onClick={refreshData}>
                Filtrar
              </Button>
            }
          >
            <Form ref={formRef} layout={"horizontal"}>
              <Form.Item
                name="startDate"
                style={{ width: "50%" }}
                label="Mês Inicial"
              >
                <DatePicker
                  defaultValue={dayjs(filterStartDate, dateFormat)}
                  format={dateFormat}
                  allowClear={false}
                  style={{ width: "100%" }}
                  picker="month"
                  placeholder="Selecione o mês"
                  onChange={setFilterStartDate}
                />
              </Form.Item>
              <Form.Item
                name="endDate"
                style={{ width: "50%" }}
                label="Mês Final"
              >
                <DatePicker
                  defaultValue={dayjs(filterEndDate, dateFormat)}
                  format={dateFormat}
                  allowClear={false}
                  style={{ width: "100%" }}
                  picker="month"
                  placeholder="Selecione o mês"
                  onChange={setFilterEndDate}
                />
              </Form.Item>
              <Form.Item style={{ width: "50%" }} name="banks" label="Bancos">
                <Select {...selectPropsBank} />
              </Form.Item>
              <Form.Item style={{ width: "50%" }} name="status" label="Status">
                <Select {...selectPropsStatus} />
              </Form.Item>
              <Form.Item
                name="typeDate"
                label="Tipo"
                style={{ width: "50%", textAlign: "left" }}
              >
                <Select
                  defaultValue={typeDate}
                  onChange={(value) => setTypeDate(value)}
                >
                  <Option value="COMPETENCE">Competência</Option>
                  <Option value="DUE_DATE">Regime de Caixa</Option>
                </Select>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
      <div style={{ width: sizeDiv }}>
        <div className="card-income"> DRE Gerencial</div>
        <Spin spinning={loadingData} size={"large"}>
          <Table
            className="table-income"
            pagination={false}
            dataSource={dataV2Open}
            bordered
            rowKey="key"
            size="small"
            scroll={{ x: size }}
            columns={ColumnsIncomeStatementExpendV2(
              "01/" + filterStartDateValidTable,
              "01/" + filterEndDateValidTable
            )}
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  if (record.type_value != "CATEGORY") {
                    let list = [];

                    dataV2Open.forEach((item) => {
                      let showChildren = item.showChildren;

                      if (record == item) {
                        showChildren = !record.showChildren;
                      }
                      list.push({
                        ...item,
                        showChildren: showChildren,
                      });
                      if (showChildren) {
                        dataV2
                          .filter(
                            (i) =>
                              i.type_value == "CATEGORY" &&
                              i.order_mapping == item.order_mapping
                          )
                          .forEach((children) => {
                            list.push({
                              ...children,
                              showDetails: showDetails,
                            });
                          });
                      }
                    });

                    if (record.showChildren == true) {
                      let listWithoutChild = [];
                      list.forEach((i) => {
                        if (
                          record.order_mapping == i.order_mapping &&
                          i.type_value == "GROUP"
                        ) {
                          listWithoutChild.push(i);
                        } else if (record.order_mapping != i.order_mapping) {
                          listWithoutChild.push(i);
                        }
                      });
                      list = listWithoutChild;
                    }

                    setDataV2Open(list);
                  }
                }, // click row
              };
            }}
          />
        </Spin>
      </div>
    </div>
  );
};
export default IncomeStatementV2;
